import {Component} from "@angular/core";

@Component({
  selector: 'geec-access-denied',
  templateUrl: './access-denied.component.html'
})
export class AccessDeniedComponent {

}
